/**
 * Content Hub Navigation
 * - Active Link Highlighting based on URL
 * - Dynamic sticky top: follows header visibility
 */
(function() {
  var nav = document.getElementById('hub-navigation');
  if (!nav) return;

  // Active link highlighting
  var links = nav.querySelectorAll('.ceq-hub-nav__link');
  var currentPath = window.location.pathname;
  links.forEach(function(link) {
    var href = link.getAttribute('href');
    if (href && currentPath === href) {
      link.classList.add('ceq-hub-nav__link--active');
    }
  });

  // Dynamic sticky: track header section class to set top position
  var headerSection = document.querySelector('.section-header');
  if (!headerSection) return;

  function updateTop() {
    if (headerSection.classList.contains('shopify-section-header-hidden')) {
      nav.style.top = '0px';
    } else {
      var headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      nav.style.top = headerHeight || '0px';
    }
  }

  // Watch for class changes on the header section (sticky/hidden)
  var observer = new MutationObserver(updateTop);
  observer.observe(headerSection, { attributes: true, attributeFilter: ['class'] });

  updateTop();
})();
